import { Subscription } from 'rxjs';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from 'app/Services/session.service';
import { HttpClientService } from 'app/Services/http-client.service';
import { AppSettings } from 'app/app-settings';
import { HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-activities-listing-body',
  templateUrl: './activities-listing-body.component.html',
  styleUrls: ['./activities-listing-body.component.css']
})
export class ActivitiesListingBodyComponent implements OnInit, OnDestroy {
  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.screenSize=event.target.innerWidth;
}
  constructor(private route: ActivatedRoute,private sessionService: SessionService,private httpClientService: HttpClientService) { }
  pageName: string;
  sub: any;
  statsModeOn: Boolean = false;
  courseName: any;
  courseClass: string = "active";
  statsClass: string = "inactive";
  screenSize:number;
  userRole:string;
  showLS360Tile: boolean = false;
  userAppcuesSplashScreenFlag = false;
  userAppcuesSplashScreenFlagSubscription:Subscription;
  viewName:string;

  toggle(passedClass: string) {

    if (passedClass == "course") {
      this.statsModeOn = false;
      this.courseClass = "active";
      this.statsClass = "inactive";
    }
    else {
      this.statsModeOn = true;
      this.courseClass = "inactive";
      this.statsClass = "active";
    }
  }

  ngOnInit() {
    this.screenSize=window.innerWidth;
    this.sub = this.route.params.subscribe(
      (params) => {
        this.pageName = params['page'];
        this.viewName = params['view'];
      }
    );


    this.userAppcuesSplashScreenFlagSubscription = this.sessionService.userAppcuesSplashScreenFlag.
    subscribe(data => {
        this.userAppcuesSplashScreenFlag = data;
    });

  }
  ngOnDestroy(): void {
    this.userAppcuesSplashScreenFlagSubscription.unsubscribe();
  }
  hidePopupSplash(examType){
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + '/api/user/appcues-splash-screen-flag',{"userAppcuesSplashScreenFlag": false}, headers)
    .subscribe(
      (data) => {
        this.userAppcuesSplashScreenFlag = false;
        this.sessionService.updateUserAppcuesSplashScreenFlagCustom(false);
        this.sessionService.updateuserInfo(1);
      }
    );
  }
}
